import React from 'react';
import LotteryHome from './LotteryHome';
import Management from './Management';
export default function Home(){
  return (
    <div>
      <LotteryHome/>
      <Management/>
    </div>
  );
}